// Constants for different requests for current reducer
export default {
  employees: 'EMPLOYEES',
  createEmployee: 'CREATE_EMPLOYEE',
  updateEmployee: 'UPDATE_EMPLOYEE',
  deleteEmployee: 'DELETE_EMPLOYEE',
  updateEmployeeFormConst: 'UPDATE_EMPLOYEE_FORM',
};
